module.exports = __webpack_public_path__ + "static/media/pro-freelancer-3.dc954690.webp";